export const ADAPTIVE_SIZE = '9999x9999';
